import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

// Основной контейнер страницы интеграций
export const IntegrationsPageContainer = styled('div')`
  max-width: 1216px;
  margin: 0 auto;
  padding: 34px 0;
`;

export const HeaderRow = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .title {
    font-weight: 700;
    font-size: 28px;
    color: ${baseTheme.colors.primary};
  }

  .actions {
    display: flex;
    gap: 12px;
    align-items: center;
  }
`;

export const ContentLayout = styled('div')`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1.6fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled('div')`
  border: 1px solid ${baseTheme.colors.stroking};
  border-radius: 8px;
  padding: 16px 16px 8px;
  background-color: ${baseTheme.colors.white};
`;

export const CardTitle = styled('div')`
  font-size: 16px;
  font-weight: 600;
  color: ${baseTheme.colors.secondary};
  margin-bottom: 12px;
`;

export const FilterRow = styled('div')`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
`;

export const InfoText = styled('div')`
  font-size: 14px;
  color: ${baseTheme.colors.tertiary};
  margin-bottom: 8px;
`;
